export class ViewPurchaseAdvice {
  loanNumber?: string;
  lenderLoanID?: string;
  sellerNumber?: string;
  servicerNumber?: string;
  date?: string;
  isExternal?: boolean;
  isServicingUpdate?: boolean;
  isServicingView?: boolean;
  isDeliveryUpdate?: boolean;
  isDeliveryView?: boolean;

  /*
    Input Validation Functions
      - Returns true if the string is empty
      - Returns false if the string is not empty
  */
  isEmpty(field: string) {
    return !(field !== undefined && field !== null && field.trim() !== '');
  }

  isEmptyDate(field: string) {
    return !(field !== undefined && field !== null && field !== '');
  }

  isValidString(field: string) {
    return field !== 'null';
  }

  // Main difference between the two forms is the loan number
  // One uses the loan number and the other uses the lender loan ID

  /*
      isValidForm Function
        - Check which form the user is using based on the loan number value
        - Returns true if all required fields are not empty
        - Returns false if one or more required fields are empty
   */
  isValidForm() {

    // User is using the lender loan ID form
    if (this.isEmpty(this.loanNumber) === true)
    {
      return (!this.isEmpty(this.loanNumber) && this.isValidString(this.loanNumber));
    }

    // User is using the loan number form
    else
    {
      return (!this.isEmpty(this.lenderLoanID) &&
        (!this.isEmpty(this.sellerNumber) || !this.isEmpty(this.servicerNumber)) &&
        !this.isEmptyDate(this.date));
    }
  }

  // Uncomment if idea above does not work
  /*
  validLenderCriteriaForm() {
    // placeholder for now
    return false;
  }


  validLoanCriteriaForm() {
    // placeholder for now
    return false;
  }
  */
}
